import { render, staticRenderFns } from "./OtherProduct.vue?vue&type=template&id=ff1b06ca&scoped=true&"
import script from "./OtherProduct.vue?vue&type=script&lang=js&"
export * from "./OtherProduct.vue?vue&type=script&lang=js&"
import style0 from "./OtherProduct.vue?vue&type=style&index=0&id=ff1b06ca&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff1b06ca",
  null
  
)

export default component.exports